import React from 'react'
import { Link } from '@sentecacommerce-theme/lib'
import styled from 'styled-components'

export const Button = ({
  label,
  link,
  onClick,
  variant = 'primary',
  target,
  className,
  children,
  fullWidth,
  icon,
  iconPosition = 'right',
  bordered = false,
  small = false,
  withCrossOver = false,
  borderRadius,
  type = 'button',
  ...rest
}: ButtonProps) => {
  const getBorderRadius = () => {
    if (!borderRadius && fullWidth) {
      return 'small'
    }

    return borderRadius || 'large'
  }

  const attrs: any = {
    'data-btn': '',
    'data-variant': variant,
    'data-border-radius': getBorderRadius(),
  }

  if (fullWidth) {
    attrs['data-fullwidth'] = ''
  }

  if (bordered) {
    attrs['data-bordered'] = ''
  }

  if (small) {
    attrs['data-small'] = ''
  }

  if (withCrossOver) {
    attrs['data-cross-over'] = ''
  }

  if (variant === 'disabled') {
    attrs['disabled'] = ''
  }

  const content = (
    <>
      {iconPosition === 'left' && icon && (
        <IconWrapper position="left">{icon}</IconWrapper>
      )}

      {children || label}

      {iconPosition === 'right' && icon && (
        <IconWrapper position="right">{icon}</IconWrapper>
      )}
    </>
  )

  if (link) {
    return (
      <Link href={link} passHref>
        <a
          className={className}
          target={target}
          onClick={onClick}
          {...attrs}
          {...rest}
        >
          {content}
        </a>
      </Link>
    )
  }

  return (
    <StyledButton
      type={type}
      className={className}
      onClick={onClick}
      {...attrs}
      {...rest}
    >
      {content}
    </StyledButton>
  )
}

export type ButtonProps = {
  label?: string
  children?: any
  link?: string
  onClick?: any
  target?: '_self' | '_blank'
  variant?:
    | 'primary'
    | 'secondary'
    | 'disabled'
    | 'light'
    | 'hint'
    | 'grey'
    | 'green'
    | 'add-to-basket'
    | 'lightgrey'
  className?: string
  fullWidth?: boolean
  icon?: React.ReactNode
  iconPosition?: 'left' | 'right'
  bordered?: boolean
  small?: boolean
  borderRadius?: 'circle' | 'large' | 'normal' | 'small' | 'none'
  disabled?: boolean
  withCrossOver?: boolean
  type?: 'submit' | 'button'
  style?: any
  as?: any
  onChange?: any
}

const IconWrapper = styled.span<{ position: 'right' | 'left' }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2rem;
  height: 2rem;
  position: absolute;
  top: 1.2rem;

  ${(props) =>
    props.position === 'right' ? 'right: 2.6rem;' : 'left: 2.6rem;'}

  & svg, img {
    width: 1.8rem;
    max-height: 1.9rem;
  }
`

const StyledButton = styled.button``
